export default {
  // Basic Information
  基本信息: "Basic Information",
  商单名称: "Campaign Name",
  请输入商单名称: "Please enter commercial order name",
  最多可输入50个字符: "Maximum 50 characters",
  请输入: "Please enter",
  商单总预算: "Total Campaign Budget",
  支付给达人的目标预算: "Target Budget for Creators",
  请输入商单总预算: "Please enter total budget",
  仅可输入数字和小数点: "Only numbers and decimal points allowed",
  预计报名时间: "Expected Registration Time",
  请选择预计报名时间: "Please select expected registration time",
  预计交付时间: "Expected Delivery Time",
  请选择预计交付时间: "Please select expected delivery time",
  提交: "Submit",

  // Brand Introduction
  品牌介绍: "Brand Introduction",
  "向达人更好地了解品牌，提升接单可能性":
    "Help creators better understand the brand and increase order acceptance rate",
  品牌名称: "Brand Name",
  品牌Logo: "Brand Logo",
  请上传文件: "Please upload file",
  "支持扩展名：.jpg .png…": "Supported extensions: .jpg .png…",
  请输入备注: "Please enter remarks",

  // Creator Requirements
  达人要求: "Creator Requirements",
  满足设置要求的达人才可参加商单并申样:
    "Only creators meeting the requirements can participate and request samples",
  粉丝量级: "Follower Level",
  "粉丝量≥": "Followers ≥",
  仅支持输入整数: "Only integers allowed",
  请输入粉丝量: "Please enter follower count",
  目标达人数: "Target Creator Count",
  请输入目标达人数: "Please enter target creator count",
  "商单预算/人": "Budget per Creator",
  请输入商单预算: "Please enter commercial order budget",

  // Product Information
  商单商品: "Commercial Order Product",
  商品信息: "Product Information",
  修改商品: "Modify Product",
  添加商品: "Add Product",
  "达人佣金%": "Creator Commission %",
  "Youpik佣金%": "Youpik Commission %",
  商品ID: "Product ID",
  所属店铺: "Store",
  店铺短码: "Store Code",
  库存: "Stock",
  佣金: "Commission",
  商品内容不能为空: "Product content cannot be empty",

  // Script and Video
  脚本范例: "Script Example",
  请选择脚本范例: "Please select script example",
  请输入文案链接: "Please enter content link",
  请输入有效链接: "Please enter valid link",
  添加脚本范例: "Add Script Example",
  参考视频: "Reference Video",
  参考视频类型: "Reference Video Type",
  请选择视频类型: "Please select video type",
  本地视频: "Local Video",
  TikTok视频链接: "TikTok Video Link",
  请输入视频链接: "Please enter video link",
  "请输入 TikTok 视频链接": "Please enter TikTok video link",
  添加参考视频: "Add Reference Video",

  // Commercial Order List
  video: "Video",
  Live: "Live",
  LiveAndVideo: "Live and Video",
  进行中: "In Progress",
  已交付: "Delivered",
  已取消: "Cancelled",
  复制商单: "Duplicate",
  编辑商单: "Edit",
  交付商单: "Deliver",
  取消商单: "Cancel",
  商单编号: "Campaign ID",
  当前预估支出: "Current Estimated Spend",
  实际支出: "Actual Expense",
  粉丝数k: "Followers ≥{num}",
  接单达人数: "Accepted Creators",
  交付视频数: "Delivered Videos",
  商单PM: "Campaign PM",
  创建时间: "Creation Time",
  交付时间: "Delivery Time",
  交付人: "Delivered By",
  分享商单: "Share Order",
  进入工作台: "Enter Workspace",
  新增商单: "Add Order",
  查看进度: "View Progress",
  工作台: "Workspace",
  查看详情: "View Details",
  总预算: "Total Budget",
  交付要求: "Delivery Requirements",
  交付内容: "Delivery Content",
  TAP挂链: "TAP Link",
  视频: "Video",
  必须: "Required",
  非必须: "Optional",
  "Ads Code": "Ads Code",
  内容数量: "Content Quantity",
  内容时长: "Content Duration",
  秒: "Seconds",
  Hashtag: "Hashtag",
  添加: "Add",
  添加商单商品: "Add Order Product",
  商品: "Product",
  商品名称: "Product Name",
  商品价格: "Product Price",
  人: "Person",
  份: "Units",
  活动ID: "Campaign ID",
  商家短码: "Merchant Code",
  商家名称: "Merchant Name",
  活动: "Campaign",
  可用: "Available",
  不可用: "Unavailable",
  状态: "Status",
  商家: "Merchant",
  目标接单达人: "Target Influencers",
  邀约达人时间: "Invitation Time",
  "平均预算/达人": "Avg. Budget per Influencer",
  目标总预算: "Target Total Budget",
  目标交付时间: "Target Delivery Time",
  预算把控: "Budget Control",
  目标预算: "Target Budget",
  "该商单开始时PM设置的总达人预算。": "Total influencer budget set by PM at the beginning.",
  预计支出: "Estimated Spending",
  "已接单达人的最终报价之和。": "Sum of final prices from accepted influencers.",
  "商单完结后,已接单达人的最终报价之和,未完结前计为0。":
    "Sum of final influencer prices after order completion; 0 before completion.",
  达人进度: "Influencer Progress",
  邀约达人数: "Number of Invited Influencers",
  申样达人数: "Sample Request Count",
  交付达人数: "Delivery Count",
  已打款达人数: "Paid Influencers",
  内容进度: "Content Progress",
  目标内容数: "Target Content Count",
  内容交付: "Content Delivered",
  合格内容: "Qualified Content",
  不合格内容: "Unqualified Content",
  交付效果: "Delivery Performance",
  总播放量: "Total Views",
  总点赞数: "Total Likes",
  总评论数: "Total Comments",
  总销售件数: "Total Sales",
  商单交付提醒: "Order Delivery Reminder",
  "交付后达人无法进行邀请、接单、申样、履约等操作":
    "After delivery, influencers cannot invite, accept orders, request samples, or fulfill.",
  "，你还要继续吗？": ", do you still want to continue?",
  商单取消提醒: "Order Cancellation Reminder",
  "取消后达人无法进行邀请、接单、申样、履约等操作":
    "After cancellation, influencers cannot invite, accept orders, request samples, or fulfill.",
  取消时间: "Cancellation Time",
  操作人: "Operator",
  全部PIC: "All PICs",
  "最多只能上传 {maxLength} 个文件": "You can upload up to {maxLength} files",
  确认提交: "Confirm Submission",
  修改后达人邀请信息将同步修改:
    "Influencer invitation info will be updated accordingly after modification",
  仅支持输入数字和小数点: "Only numbers and decimal points are allowed",
  请输入有效的URL链接: "Please enter a valid URL link.",
  "请输入 Ads code": "Please enter the Ads code.",
  "仅可输入数字和小数点，最多两位小数":
    "Only numbers and decimal points are allowed, with a maximum of two decimal places.",
  确认创建: "Confirm Creation",
  视频不大于50M: "Videos should not exceed 50MB.",
  图片不大于5M: "Images should not exceed 5MB.",
  视频链接重复: "Video link already exists.",
  内容: "Content",
  adsCode码重复: "Ads Code already exists.",
  查看数据: "View Data",
  最多添加10个标签: "You can add a maximum of 10 tags.",
  仅可输入整数: "Only integers are allowed.",
  总订单数: "Total Orders",
  返回: "Back",
  单: "Order",
  "达人发布内容后，将以该要求做为检测合格的标准":
    "The content published by the creator will be evaluated based on this requirement.",
  "符合以上粉丝量级的接受商单目标达人人数。":
    "Number of target creators accepting campaigns with the above follower range.",
  "和达人谈单时不可超过该预算。": "Do not exceed this budget when negotiating with the creator.",
  确认取消保存: "Confirm Cancel Save",
  取消后编辑的内容将不会保存: "Changes will not be saved. Continue?"
};
